import angular from 'angular';
import { attListIconsComponent } from './attListIconsComponent';

angular
	.module('sh.attListIcons', ['sh.attService', 'sh.clickToDownload'])
	.component('shAttListIcons', attListIconsComponent());
